import { defineComponent as _defineComponent } from 'vue'
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import { useAlert } from "@rmp/core/composables/useAlert";
import { computed } from "vue";

export interface AlertProps {
	customBackgroundColor?: string;
	customIcon?: string;
	iconColor?: string;
	text?: string;
	noTextCaption?: boolean;
	iconSize?: string | number;
	type?: string;
	px?: string | number;
	width?: string;
	maxWidth?: string;
	height?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpAlert',
  props: {
    customBackgroundColor: null,
    customIcon: null,
    iconColor: null,
    text: null,
    noTextCaption: { type: Boolean, default: true },
    iconSize: { default: "24" },
    type: { default: "info" },
    px: { default: 4 },
    width: null,
    maxWidth: null,
    height: null
  },
  setup(__props: any) {

const props = __props as { customBackgroundColor?: string, customIcon?: string, iconColor?: string, text?: string, noTextCaption: boolean, iconSize: string | number, type: string, px: string | number, width?: string, maxWidth?: string, height?: string };



const {
	type,
	customIcon,
	backgroundColor
} = useAlert(props);

const icon = computed(() => {
	return customIcon.value || `ico_${type.value}`;
});

const alertStyle = computed(() => ({
	backgroundColor: `${backgroundColor.value}26 !important`,
	color: `${backgroundColor.value} !important`,
	width: props.width ? props.width : "fit-content",
	maxWidth: props.maxWidth ? props.maxWidth : "unset",
	height: props?.height ? props?.height : "unset",
}));

return { __sfc: true,props, type, customIcon, backgroundColor, icon, alertStyle, RmpIcon }
}

})